<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <!-- <search-field ref="searchRef" @search="search"></search-field> -->
            <v-spacer></v-spacer>
            <add-button @add="openAddDialog"></add-button>
            <!-- <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel</span>
            </v-tooltip> -->
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="refreshData()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>
            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <module-container
                v-if="dialogType === 'module'"
                :page_id="viewData.id"
              ></module-container>

              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md6>
                    <!-- Insert View Dialog Content BELOW-->

                    <details-container
                      v-if="dialogType !== 'module'"
                      ref="detailsRef"
                      :data="viewData"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'edit'
                  ? saveEditDialog()
                  : dialogType === 'add'
                  ? saveAddDialog()
                  : dialogType === 'multiple'
                  ? saveMultiAssignDialog()
                  : dialogType === 'settings'
                  ? saveSettingsDialog()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>

            <message-dialog
              :dialog="messageDialog"
              :title="messageTitle"
              :message="messageText"
              @save="dialogType === 'remove' ? saveRemoveDialog() : ''"
              @close="closeMessageDialog"
              :loading="messageLoading"
            ></message-dialog>
          </v-card-title>

          <v-divider></v-divider>

          <!-- <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4> </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container> -->

          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.version }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.purchase_amount
                    ? $amountInPeso(props.item.purchase_amount)
                    : "--"
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.credit_amount
                    ? $amountInPeso(props.item.credit_amount)
                    : "--"
                }}
              </td>
              <td class="text-xs-center">{{ props.item.claim_duration }}</td>
              <td class="text-xs-center">{{ props.item.claim_duration }}</td>
              <td class="text-no-wrap text-xs-center">
                <edit-button @edit="openEditDialog(props.item)"></edit-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/SmsDetailsContainer.vue";
import moment from "moment";
var now = new Date();
// import XLSX from "xlsx";

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      dialogue: false,
      cancelDialog: false,
      confirmLoading: false,
      dialogLoading: false,
      items: [],
      title: "View All SMS Template",
      headers: [
        { text: "#", align: "left", sortable: false },
        {
          text: "ID",
          align: "center",
          value: "id",
          sortable: false,
        },
        {
          text: "Template",
          align: "center",
          value: "template",
          sortable: false,
        },
        {
          text: "Description",
          align: "center",
          value: "description",
          sortable: true,
        },
        {
          text: "Project",
          align: "center",
          value: "project",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          value: "status",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
      data: {},
      viewData: {
        purchase_amount: 40,
        credit_amount: 60,
      },
      queryParams: {
        search: null,
        limit: 10,
        offset: 0,
      },
      dialogLoading: false,
      dialogType: "",
      dialogTitle: "",
      dialogStatus: false,
      openConfirmDialog: false,
      confirmLoading: false,
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false,
      valid: true,
      dateFromMenu: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateToMenu: false,
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      uploadLoading: false,
      valid: true,
      totalItems: 0,
    };
  },
  created: async function() {
    // await this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {},
  methods: {
    async getData() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getSmsTemplate(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }

        if (this.totalItems <= this.queryParams.limit) {
          this.disabledLimit = true;
        } else {
          this.disabledLimit = false;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async saveAddDialog() {
      this.confirmLoading = true;
      const data = this.$refs.detailsRef.computedData,
        body = {
          user_id: data.user_id,
          template: data.template,
          description: data.description,
          status: data.status,
          project: data.project,
        };
      try {
        const response = await Services.addTemplate(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Template has been added!",
          });
          this.viewData = {
            version: data,
          };
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();

            this.$store.dispatch("dispatchUnauthorized", true);
          } else if (error.response.status === 422) {
            this.$infoBar({
              type: "error",
              text: `${this.$capitalizeFirstLetter(
                error.response.data.message
              )} `,
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      this.confirmLoading = await false;
    },
    openEditDialog() {},
    async openRemoveDialog(data) {
      this.messageDialog = true;
      this.messageTitle = "Remove " + this.title;
      this.messageText = `Are you sure you want to Remove this ${this.title}?`;
      this.dialogType = "remove";

      this.viewData = {
        version: data,
      };
    },
    // async saveRemoveDialog() {
    //   this.messageLoading = true;
    //   try {
    //     const response = await Services.deleteVersion(this.viewData.version);

    //     if (response.status === 200 || response.status === 201) {
    //       this.closeMessageDialog();

    //       await this.getData();

    //       this.$infoBar({
    //         type: "success",
    //         text: "Version has been removed!",
    //       });
    //     } else {
    //       this.$infoBar({
    //         type: "error",
    //         text: "Server Error!",
    //       });
    //     }
    //   } catch (error) {
    //     if (!error.response) {
    //       this.$infoBar({
    //         type: "error",
    //         text: "No network or server connection",
    //       });
    //     }
    //   }
    //   this.messageLoading = false;
    // },
    async closeMessageDialog() {
      this.messageDialog = false;
      this.viewData = {};
    },
    closeDialog() {
      this.viewData = {};

      this.closeConfirmDialog();
      this.dialogTitle = "";
      this.dialogType = "";
      this.dialogStatus = false;
    },
    openMultiDeleteDialog() {
      this.deleteDialog = true;
      this.deleteType = "multiple";
      this.deleteTitle =
        "Are you sure you want to Delete this " + this.title + "s";
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
      this.openConfirmDialog = true;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    refreshData() {
      this.getData();
    },
  },
};
</script>

<style scoped></style>
